import { api } from './api';

// Aceita File/Blob do browser, converte pra base64, envia ao backend e
// devolve a URL pública. Max 5MB. Mime types aceitos: image/jpeg|png|webp|gif.

const MAX_BYTES = 5 * 1024 * 1024;

function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Não consegui ler o arquivo. Tente outro.'));
    reader.readAsDataURL(file);
  });
}

// Traduz falha bruta de rede/HTTP em mensagem PT-BR amigável.
function friendlyUploadError(err) {
  // fetch rejeita com TypeError quando offline/CORS/DNS falha — sem `status`.
  if (err instanceof TypeError || err.name === 'TypeError') {
    return 'Sem conexão com o servidor. Verifique sua internet e tente novamente.';
  }
  if (err?.status === 413) {
    return 'Imagem muito grande. O limite é 5 MB — comprima ou escolha outra.';
  }
  if (err?.status === 415 || err?.status === 422) {
    return err.message || 'Formato de imagem não suportado. Use JPG, PNG, WEBP ou GIF.';
  }
  if (err?.status >= 500) {
    return 'Erro no servidor ao processar a imagem. Tente de novo em instantes.';
  }
  return err?.message || 'Não foi possível enviar a imagem.';
}

export const uploadService = {
  async uploadImage(file) {
    if (!file) throw new Error('Arquivo não informado');
    if (file.size > MAX_BYTES) {
      throw new Error('Imagem muito grande. O limite é 5 MB — comprima ou escolha outra.');
    }
    try {
      const dataUrl = await readFileAsBase64(file);
      const base64 = dataUrl.split(',').pop();
      return await api.post(
        '/api/uploads',
        { fileBase64: base64, mimeType: file.type },
        { includeStore: false }
      );
    } catch (err) {
      const friendly = new Error(friendlyUploadError(err));
      friendly.cause = err;
      throw friendly;
    }
  }
};

export default uploadService;
